function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "4xlheurq2a",
  colorInterpolationFilters: "auto"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#4xlheurq2a)",
  transform: "translate(-280.000000, -632.000000) translate(0.000000, 216.000000)"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#FDA805",
  transform: "translate(280.000000, 416.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.5
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M9.711 3.51l-1.22 2.826h2.853L6.757 11.56l1.285-3.767-2.487-.001 1.509-4.123c-.004-.019.007-.038.018-.059l.01-.024 2.619-.076z"
})))));
const SvgUiIconUtility16ElectricityCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUiIconUtility16ElectricityCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ui-icon-utility-16-electricity-circle.f3b41636.svg";
export { ForwardRef as ReactComponent };